/**
 * dateUtils.ts
 * Thư viện tiện ích chuẩn hóa định dạng ngày & giờ cho toàn bộ Frontend 3D Smart.
 * Bắt buộc hiển thị theo múi giờ Việt Nam (Asia/Ho_Chi_Minh - GMT+7).
 */

const VN_TIMEZONE = 'Asia/Ho_Chi_Minh';

/**
 * Định dạng ngày: DD/MM/YYYY (theo giờ Việt Nam)
 * Ví dụ: "18/09/2026"
 */
export function formatVnDate(date: string | number | Date | null | undefined): string {
  if (!date) return 'N/A';
  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A';

  return new Intl.DateTimeFormat('vi-VN', {
    timeZone: VN_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d);
}

/**
 * Định dạng ngày giờ chi tiết: DD/MM/YYYY HH:mm (theo giờ Việt Nam)
 * Ví dụ: "18/09/2026 23:45"
 */
export function formatVnDateTime(date: string | number | Date | null | undefined): string {
  if (!date) return 'N/A';
  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A';

  return new Intl.DateTimeFormat('vi-VN', {
    timeZone: VN_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
}

/**
 * Định dạng giờ: HH:mm (theo giờ Việt Nam)
 * Ví dụ: "23:45"
 */
export function formatVnTime(date: string | number | Date | null | undefined): string {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  return new Intl.DateTimeFormat('vi-VN', {
    timeZone: VN_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
}

/**
 * Tính số ngày còn lại đến hạn (tính theo ngày lịch)
 */
export function getDaysLeft(expiresAt: string | number | Date | null | undefined): number {
  if (!expiresAt) return 0;
  const exp = new Date(expiresAt).getTime();
  if (isNaN(exp)) return 0;
  return Math.ceil((exp - Date.now()) / (24 * 60 * 60 * 1000));
}
